<script setup lang="ts">
  import { ProfilesFullItem } from '@/views/profile'

  definePage({
    meta: { layout: 'baseNew' },
  })

  const router = useRouter()
  const route = useRoute('/profile/[id]/')
  const profileId = computed(() => route.params.id as string)

  const handleNavigateBack = () => {
    router.push({ name: '/profiles' })
  }
</script>

<template>
  <ProfilesFullItem
    :profile-id="profileId"
    @navigate-back="handleNavigateBack"
  />
</template>
